import { Children } from 'react'
import styled from 'styled-components'

import { colors } from '@/styles'

import Input from './input'

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 0;
  > input {
    cursor: auto !important;
  }
  > label {
    margin-left: 8px;
    font-size: 14px;
    color: ${colors.grey24};
    font-weight: 500;
  }
  > input[aria-checked='true'] + label {
    color: #333;
  }
`

const RadioButton = ({
  error = '',
  children = null,
  id = undefined,
  ...rest
}) => (
  <Wrapper>
    <Input id={id} type="radio" {...rest} />
    {error}
    {Children.count(children) > 0 && <label htmlFor={id}>{children}</label>}
  </Wrapper>
)

export default RadioButton
